import React, { useState, useEffect, useMemo } from "react";
import { Bills } from "../../pages";
import { billsStore } from "../../stores";
import { BillsController } from "../../controllers";

const BillsContainer = () => {
  const [loading, setLoading] = useState(false);
  const [limit, setLimit] = useState(50);
  const [filterQuery, setFilterQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");

  const billsTableQuery = useMemo(() => {
    return `offset=${currentPage + 1}&limit=${limit}`;
  }, [currentPage, limit]);

  const { isLoading, data, isFetching } = BillsController.useGetAllBills(
    billsTableQuery,
    filterQuery,
    searchQuery
  );

  const onLimitChange = (limit) => {
    setLimit(limit);
    setCurrentPage(0);
  };

  useEffect(() => {
    setLoading(true);
    const setBills = async () => {
      await Promise.all([BillsController.getBillsAnalysis()]);
      setLoading(false);
    };
    setBills();
  }, [billsStore]);

  return (
    <Bills
      loading={loading}
      allBills={billsStore.allBills}
      billsAnalysis={billsStore.billsAnalysis}
      isLoading={isLoading}
      data={data}
      isFetching={isFetching}
      limit={limit}
      onLimitChange={onLimitChange}
      setFilterQuery={setFilterQuery}
      setSearchQuery={setSearchQuery}
      currentPage={currentPage}
      setCurrentPage={setCurrentPage}
    />
  );
};
export default BillsContainer;
